// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_18-2";
export var blackBorderOnHover = "_18-7";
export var cell = "_18-6";
export var cellContainer = "_18-3";
export var checked = "_18-8";
export var disabled = "_18-5";
export var featuredIconCellContainer = "_18-9";
export var featuredIconTextContainer = "_18-b";
export var featuredIconWrapper = "_18-a";
export var noBorder = "_18-c";
export var orangeSelectedRow = "_3c-3";
export var overflowableText = "_18-0";
export var overflowableTextContainer = "_18-1";
export var row = "_11-0";
export var rowCheckboxCell = "_18-4";
export var selectableTable = "_3c-2";